import { errors, utils as Utils } from ".";

if (!window.configuration) {
  require("../../static/config/config.js");
}

const requireModule = (name) => {
  return new Promise(async (resolve, reject) => {
    global.requirejs(
      [`${name}js`, `css!${name}css`],
      (lib) => {
        if (lib && lib.default) {
          resolve({ name, module: lib.default });
        } else {
          console.error(errors.not_found(name));
          reject();
        }
      },
      (error) => {
        console.error(errors.not_found(name));
        console.error(error);
        reject(name);
      }
    );
  });
};

const removeElementChildren = (node) => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

const mountModule = (module) => {
  module.$mount();
  const moduleWrapper = document.getElementById("module-wrapper");
  if (!moduleWrapper) throw Error("Recarregue a página em uma rota válida");
  removeElementChildren(moduleWrapper);
  moduleWrapper.appendChild(module.$el);
};

const render = (name, vm) => {
  const modules = vm.modules;
  return new Promise((resolve, reject) => {
    requireModule(name).then(
      ({ name, module }) => {
        modules[name] = module;
        modules[name].$router.beforeEach((to, from, next) => {
          const moduleName = Utils.getModuleName(to.path);
          const currentModuleName = Utils.getModuleName(from.path);
          if (currentModuleName === name && moduleName !== currentModuleName) {
            vm.loadRoute(to, from, next, true);
          } else {
            next();
          }
        });
        modules[name].$router.afterEach((to) => {
          if (to.meta && to.meta.title) {
            window.document.title = to.meta.title || "SGU Suite";
          } else {
            window.document.title = "SGU Suite";
          }
          vm.$router.push(to.path);
        });

        resolve({ module });
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export default {
  push(name, currentName, vm) {
    const modules = vm.modules;

    return new Promise(async (resolve, reject) => {
      if (name === currentName && modules[name]) {
        resolve({ module: modules[name] });
      } else if (modules[name]) {
        mountModule(modules[name]);
        modules[name].$nextTick(() => {
          resolve({ module: modules[name] });
        });
      } else {
        render(name, vm).then(
          ({ module }) => {
            mountModule(module);
            module.$nextTick(() => {
              resolve({ module });
            });
          },
          () => {
            reject();
          }
        );
      }
    });
  },
  render,
};
